import { AdvertiserProfileForm } from '../interfaces';

/**
 * Configuration for the advertiser profile form fields.
 */
export const ADVERTISER_PROFILE_FORM_FIELDS: AdvertiserProfileForm[] = [
    {
        id: 'dealerName',
        label: 'Select Dealer Business Name',
        placeholder: 'Ex. NCompass TV',
        type: 'autocomplete',
        required: true,
        fullWidth: true,
    },
    {
        id: 'advertiserName',
        label: 'Advertiser Name',
        placeholder: 'Ex. SM Center Pasig',
        type: 'input',
        required: true,
        fullWidth: true,
    },
    {
        id: 'category',
        label: 'Category',
        placeholder: 'Ex. Fried Chicken Restaurant',
        type: 'input',
        required: true,
        fullWidth: false,
    },
    {
        id: 'generalCategory',
        label: 'General Category',
        placeholder: 'Ex. Restaurant',
        type: 'input',
        required: false,
        fullWidth: false,
    },
    {
        id: 'latitude',
        label: 'Latitude',
        placeholder: 'Ex. 58.933',
        type: 'input',
        required: false,
        fullWidth: false,
    },
    {
        id: 'longitude',
        label: 'Longitude',
        placeholder: 'Ex. 58.933',
        type: 'input',
        required: false,
        fullWidth: false,
    },
    {
        id: 'address',
        label: 'Address',
        placeholder: '',
        type: 'input',
        required: false,
        fullWidth: false,
    },
    {
        id: 'city',
        label: 'City',
        placeholder: '',
        type: 'input',
        required: false,
        fullWidth: false,
    },
    {
        id: 'state',
        label: 'State',
        placeholder: '',
        type: 'input',
        required: false,
        fullWidth: false,
    },
    {
        id: 'region',
        label: 'Region',
        placeholder: '',
        type: 'input',
        required: false,
        fullWidth: false,
    },
    {
        id: 'zipCode',
        label: 'Zip Code',
        placeholder: 'Ex. 60606',
        type: 'input',
        required: false,
        fullWidth: false,
    },
];
